export default __webpack_public_path__ + "static/media/question-mark.82fb9723.svg";